export const LANG = {
    SC: 'zh-cn',
    TC: 'zh-hk',
    EN: 'en-us',
    JA: 'ja',
};

export const LANG_OPTIONS = [
    { label: '简体', value: LANG.SC },
    { label: '繁体', value: LANG.TC },
    { label: '英文', value: LANG.EN },
    { label: '日语', value: LANG.JA },
];

// https://gitlab.futunn.com/nodepackage/lang
export const LANG_NUM_MAP = {
    [LANG.SC]: 0,
    [LANG.TC]: 1,
    [LANG.EN]: 2,
    [LANG.JA]: 5
};
